import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const location = useLocation();
    const [isChecking, setIsChecking] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        // Check authentication
        const token = localStorage.getItem('access_token');
        console.log('🔒 ProtectedRoute - Checking auth, token exists:', !!token);
        
        setIsAuthenticated(!!token);
        setIsChecking(false);
    }, [location]);

    if (isChecking) {
        return (
            <div className="min-h-screen bg-vintage-cream flex items-center justify-center">
                <p className="text-vintage-brown font-serif">Loading...</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        console.log('❌ Not authenticated, redirecting to login');
        return <Navigate to="/admin/login" replace />;
    }

    console.log('✅ Authenticated, rendering protected content');
    return <>{children}</>;
};
